// Chave do produto extra no carrinho lateral (Nano · Carrinho). Ligar adiciona 1 unidade do produto
// escolhido nas configurações do tema; desligar tira a linha. Depois o carrinho é redesenhado com a mesma
// seção que o tema usa ao mudar quantidades. Se o extra ficar sozinho no carrinho, ele sai sozinho.
if (!customElements.get('nano-cart-addon')) {
  customElements.define(
    'nano-cart-addon',
    class NanoCartAddon extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('.nc-addon__input');
        if (!this.input) return;
        this.input.addEventListener('change', () => this.toggle(this.input.checked));
        if (this.hasAttribute('data-only-addon')) this.toggle(false);
      }

      async toggle(on) {
        if (this.busy) return;
        this.busy = true;
        this.setAttribute('aria-busy', 'true');
        this.input.disabled = true;
        const routes = window.routes || {};
        const section = 'minicart-form';
        const post = (body) => ({
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ ...body, sections: section, sections_url: window.location.pathname }),
        });
        try {
          let response;
          let cart;
          if (on) {
            response = await fetch(
              `${routes.cart_add_url || '/cart/add'}.js`,
              post({ items: [{ id: Number(this.dataset.variantId), quantity: 1 }] })
            );
          } else {
            response = await fetch(
              `${routes.cart_change_url || '/cart/change'}.js`,
              post({ id: this.dataset.lineKey || this.dataset.variantId, quantity: 0 })
            );
          }
          const data = await response.json();
          if (!response.ok) {
            const failure = new Error(data.description || data.message || '');
            failure.fromCart = true;
            throw failure;
          }
          // /cart/add.js devolve só o item adicionado; o carrinho inteiro vem do /cart.js.
          cart = on ? await (await fetch(`${routes.cart_url || '/cart'}.js`)).json() : data;
          this.render(data.sections && data.sections[section], cart);
        } catch (error) {
          this.input.checked = !on;
          // Mensagem da Shopify quando ela explica o motivo (ex.: sem estoque); senão, o aviso de erro do tema.
          const message = (error.fromCart && error.message) || (window.cartStrings && window.cartStrings.error);
          if (message && typeof showToast === 'function') showToast(message, 4000, 'modal-error');
        } finally {
          this.busy = false;
          this.removeAttribute('aria-busy');
          this.input.disabled = false;
        }
      }

      render(html, cart) {
        const drawer = document.getElementById('minicart-form');
        const fresh = html && new DOMParser().parseFromString(html, 'text/html').querySelector('#minicart-form');
        if (drawer && fresh) drawer.innerHTML = fresh.innerHTML;
        document.querySelectorAll('.cart-count').forEach((el) => {
          if (el.classList.contains('cart-count-drawer')) {
            el.innerHTML = `(${cart.item_count})`;
          } else {
            el.innerHTML = cart.item_count > 100 ? '~' : cart.item_count;
          }
        });
        const total = document.querySelector('header-total-price');
        if (total && typeof total.updateTotal === 'function') total.updateTotal(cart);
        const freeShipping = document.querySelector('free-ship-progress-bar');
        if (freeShipping && typeof freeShipping.init === 'function') freeShipping.init(cart.items_subtotal_price);
        const notification = document.querySelector('cart-notification');
        if (notification && typeof notification.cartAction === 'function') notification.cartAction();
      }
    }
  );
}
